module.exports = __webpack_public_path__ + "static/markus-spiske-221494-unsplash-ae879d8a06e6163458919a1b7595ae2a.jpg";